import React, { Component } from 'react';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { MenuComponent } from '../MenuComponent';
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../GlobalContext';

export class SelectStocktake extends Component {
    static displayName = SelectStocktake.name;

    constructor(props) {
        super(props);
        this.history = props.history;
        this.state = {
            alertMessage: "",
            openStockTakes: [],
            selectedStocktakeId: "",
            selectedNamecode: "",
            isScanStocktake: "",
            selectedClientName: "",
            selectedStocktakeNumber:""
    
        }
    }

    componentDidMount() {
        this.loadOpenStocktakes();

    }
    goto(page) {
        this.history.push(page);
    }

    async loadOpenStocktakes() {
        this.state.loading = true;

        var warehouseID = MyGlobal.warehouse;
        fetch(`api/Stocktake/GetOpenStocktakes`)
            .then(async response => {

                this.state.loading = false;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    this.setState({ openStockTakes: [], alertMessage: errorText });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;
                  

                    if (apiResponse) {
                        const data = apiResponse.data;
                        if (apiResponse.success) {
                            this.setState({ openStockTakes: data, alertMessage: "" });
                        }
                        else {
                            this.setState({ alertMessage: "Failed to load Stock takes!!  " + apiResponse.errorMessage });
                        }
                    }
                    else {
                        this.setState({ alertMessage: "Failed to load Stock takes!!" });
                    }
                }

            })
            .catch(error => {
                this.setState({ openStockTakes: [], alertMessage: error });
            });
    }

    selectTask(selectedStocktake) {

        MyGlobal.selected_stocktake = JSON.stringify({
            namecode: selectedStocktake.clientCode,
            stocktakeId: selectedStocktake.stocktakeID,
            isScanStocktake: selectedStocktake.isScanStocktake
        });

        this.history.push({
            pathname: 'StocktakeTasks',
            state: { namecode: selectedStocktake.clientCode, stocktakeId: selectedStocktake.stocktakeID, isScanStocktake: selectedStocktake.isScanStocktake }
        });
    }


    render() {
  
       

        let openStocktakesHtml = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderOpenStocktakes();

        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";

        return (
            <div>
                <Container>
                    <Row className="mb-3">
                        <Col xs={9}><h4>Select Stocktake</h4></Col>
                        <Col xs={3}><button type="button" className="btn btn-success col-12 mb-2" onClick={() => { this.goto('../MainMenu'); }} >
                            Back
                        </button></Col>
                    </Row>
                    <Row>
                        <Col>{alertMessage}</Col>
                    </Row>
                    <Row>
                        <Col>
                            <button type="button" className="btn btn-success col-12 mb-2" onClick={() => { this.loadOpenStocktakes(); }}>Refresh</button>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="tableHolder hm-50vh mb-3">
                                {openStocktakesHtml}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

        );
    }

    renderOpenStocktakes() {

        return (
            <div>
                <table className='table table-striped' aria-labelledby="tabelLabel">
                    <thead style={{ position: 'sticky', top: -2, background: 'white' }}>
                        <tr>
                            <th className="col-sm-4">
                                <label>Client Code</label>
                                <br />
                                <input className="col-sm-4" ref="namecodeInput" value={this.state.selectedNamecode} onChange={(e) => { this.setState({ selectedNamecode: e.target.value }); }} />
                            </th>
                            <th className="col-sm-4">
                                <label>Stocktake Number</label>
                                <br />
                                <input className="col-sm-4" value={this.state.selectedStocktakeNumber} onChange={(e) => { this.setState({ selectedStocktakeNumber: e.target.value }); }} /> <br />
                            </th>
                            <th className="col-sm-4">
                                <label>Client Name</label>
                                <br />
                                <input className="col-sm-4" value={this.state.selectedClientName} onChange={(e) => { this.setState({ selectedClientName: e.target.value }); }} />
                            </th>
                            



                        </tr>
                    </thead>
                    <tbody>
                        {this.state.openStockTakes
                            .filter((item) =>

                                (!this.state.selectedNamecode.length ||

                                    item.clientCode
                                        .toString()
                                        .toLowerCase()
                                        .includes(this.state.selectedNamecode.toString().toLowerCase())


                                ) &&
                                (!this.state.selectedStocktakeNumber.length ||

                                    item.stocktakeNumberDisplay
                                        .toString()
                                        .toLowerCase()
                                    .includes(this.state.selectedStocktakeNumber.toString().toLowerCase())
                                )
                                &&
                                (!this.state.selectedClientName.length ||

                                    item.clientName
                                        .toString()
                                        .toLowerCase()
                                    .includes(this.state.selectedClientName.toString().toLowerCase())
                                )
                            )
                            .map(row =>
                                <tr key={row.stocktakeID} onClick={() => { this.selectTask(row) }}>
                                    <td>{row.clientCode}</td>
                                    <td>{row.stocktakeNumberDisplay}</td>
                                    <td>{row.clientName}</td>
 
                                </tr>
                            )}
                    </tbody>
                </table>
            </div>
        );
    }
}